import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import useStyles from "./style";
import { Typography } from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useSnackbar } from "notistack";
import AccessAlarmsIcon from "@material-ui/icons/AccessAlarms";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import { useData } from "../../../../components/firebase/DataProvider";
import Gap from "../../../../components/Gap";
import {
  FieldValue,
  firestore,
} from "../../../../components/firebase/FirebaseProvider";
import currency from "../../../../utils/currency";
import Header from "../../../../components/molecules/Header";
import Item from "./item";
import Pengiriman from "./pengiriman";
import Bayar from "./bayar";
import Infaq from "./infaq";
import Voucher from "./voucher";
import Alamat from "./alamat";
import CopyToClipboard from "react-copy-to-clipboard";
import DialogPembayaran from "./dialogPembayaran";

function WaitingForPayment() {
  const { orders } = useData();

  const history = useHistory();

  const pendingOrders =
    orders &&
    orders.filter((order) => {
      return order.status === "not-paid" || order.status === "pending";
    });

  if (pendingOrders && pendingOrders.length <= 0) {
    return (
      <>
        <Gap height={16} />
        <Button
          variant="outlined"
          color="primary"
          onClick={() => history.push("/")}
          style={{ textTransform: "capitalize" }}
        >
          Belanja Sekarang
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography>
        Ada {pendingOrders && pendingOrders.length} pesanan menunggu pembayaran!
      </Typography>
      <Gap height={16} />
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          history.push("/transaksi/transaksilist/sellerapp/tokorame");
        }}
        style={{ textTransform: "capitalize" }}
      >
        Cek di Transaksi
      </Button>
    </>
  );
}

function Checkout() {
  const classes = useStyles();
  const history = useHistory();
  const { cart, cartRef, orders } = useData();
  const [loadDebounce, setLoadDebounce] = useState(false);
  const [invalidJumlah, setInvalidJumlah] = useState({});
  const [loadDelivery, setLoadDelivery] = useState(false);
  const [openPembayaran, setOpenPembayaran] = useState({
    open: false,
    is_payment_name: "",
    is_payment_code: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  const pendingOrders =
    orders?.filter?.((order) => {
      return (
        (order.order_info?.location === "sellerapp" &&
          order.status === "not-paid") ||
        order.status === "pending"
      );
    }) ?? [];

  const subcarts = Object.entries(cart?.subcarts ?? {}).sort((a, b) => {
    return a[1].created_at?.toMillis?.() - b[1].created_at?.toMillis?.();
  });

  const cartY = subcarts?.filter(([key, value]) => value.checked === "Y");
  const alamatIdCartPertama = cartY?.[0]?.[0];
  const dataCartPertama = cartY?.[0]?.[1];

  const boolInvalidJumlah = Object.values(invalidJumlah).some(
    (item) =>
      Object.values(item?.total ?? {})?.reduce((n1, n2) => n1 + n2, 0) >
      item?.stok
  );

  const callSetInvalidJumlah = useCallback((id, stok, alamatId, jumlah) => {
    setInvalidJumlah((old) => {
      if (!old.hasOwnProperty(id)) {
        old[id] = {
          stok,
          total: { [alamatId]: jumlah },
        };
      } else {
        old[id].total[alamatId] = jumlah;
        old[id].stok = stok;
      }

      return { ...old };
    });
  }, []);

  return (
    <>
      <Header
        title="Checkout"
        type="with-title"
        onClick={() => history.goBack()}
      />
      <Gap height={60} />
      {!cart || cartY?.length <= 0 ? (
        <div className={classes.emptyCart}>
          <Typography className={classes.emptyCartTitle}>
            Wah, keranjang checkoutmu masih kosong
          </Typography>
          <WaitingForPayment />
        </div>
      ) : (
        <>
          {" "}
          <div style={{ paddingBottom: 70 }}>
            {/* <Gap height={50} /> */}
            <Divider />
            {pendingOrders.length > 0 ? (
              <>
                <div
                  className={classes.wrapNotif}
                  onClick={() =>
                    history.push("transaksi/transaksilist/sellerapp/tokorame")
                  }
                >
                  <AccessAlarmsIcon style={{ color: "#5AA5EA" }} />
                  <Gap width={6} />
                  <Typography className={classes.liquidNotif}>
                    {pendingOrders.length} Pesananmu belum dibayar nih, yuk
                    bayar sekarang
                  </Typography>
                </div>
                <Divider style={{ backgroundColor: "#5AA5EA" }} />
              </>
            ) : null}
            <CopyToClipboard
              text={cart?.kode_order}
              onCopy={() => {
                enqueueSnackbar("Kode Order Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "13px",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  // marginTop: "-20px",
                  // marginBottom: "-20px",
                }}
              >
                <Typography className={classes.liquidPrimary}>
                  Kode Order: {cart?.kode_order}
                </Typography>
                <Typography color="primary" className={classes.liquidPrimary}>
                  <FileCopyOutlinedIcon style={{ fontSize: 11 }} /> Salin
                </Typography>
              </div>
            </CopyToClipboard>{" "}
            <Paper elevation={0}>
              {subcarts?.map?.(([alamatId, subcart]) => {
                const products = Object.entries(subcart.products ?? {});
                const check = subcart?.checked;
                if (check === "N") {
                  return null;
                }
                return (
                  <ItemCart
                    alamatId={alamatId}
                    subcart={subcart}
                    products={products}
                    callSetInvalidJumlah={callSetInvalidJumlah}
                    setLoadDebounce={setLoadDebounce}
                    loadDebounce={loadDebounce}
                    setLoadDelivery={setLoadDelivery}
                    loadDelivery={loadDelivery}
                    invalidJumlah={invalidJumlah}
                    cartRef={cartRef}
                    tipe_order={cart.tipe_order}
                  />
                );
              })}
            </Paper>
          </div>
          <div
            style={{
              position: "fixed",
              backgroundColor: "white",
              bottom: 0,
              maxWidth: "100%",
              width: "960px",
              left: "auto",
              right: "auto",
            }}
          >
            <Bayar
              isUniqueCode={cart?.unique_code}
              subcarts={subcarts}
              boolInvalidJumlah={boolInvalidJumlah}
              loadDebounce={loadDebounce}
              loadDelivery={loadDelivery}
              // setDialogMoota={setDialogMoota}
            />
          </div>
          <DialogPembayaran
            open={openPembayaran?.open}
            data={dataCartPertama}
            is_payment_code={openPembayaran?.is_payment_code}
            is_payment_name={openPembayaran?.is_payment_name}
            alamatId={alamatIdCartPertama}
            handleClose={() =>
              setOpenPembayaran({
                open: false,
                is_payment_name: "",
                is_payment_code: "",
              })
            }
          />
        </>
      )}
    </>
  );
}

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

async function getDataVoucher(nama_voucher, profil_id) {
  let newVoucherRef;
  const voucherList = firestore.collection("vouchers");
  const voucher = await voucherList.doc(nama_voucher).get();

  try {
    if (voucher.exists) {
      newVoucherRef = voucher.data();
    } else {
      const voucherList = firestore.collection(`users/${profil_id}/vouchers`);
      const voucher = await voucherList.doc(nama_voucher).get();
      newVoucherRef = voucher.data();
    }
  } catch (error) {
    console.log("error when choose ref voucher", error.message);
  }

  const datas = newVoucherRef;
  return datas;
}

const ItemCart = ({
  alamatId,
  subcart,
  products,
  callSetInvalidJumlah,
  setLoadDebounce,
  loadDebounce,
  setLoadDelivery,
  loadDelivery,
  invalidJumlah,
  cartRef,
  tipe_order,
}) => {
  const classes = useStyles();
  const {
    campaignsInfaq,
    profil,
    level,
    global_komisi,
    preorderUtils,
    voucherData,
    global_settings,
  } = useData();
  const { enqueueSnackbar } = useSnackbar();
  const [dataVoucher, loadDataVoucher] = useDocumentData(
    firestore.doc(`vouchers/${subcart?.promo_voucher}`),
    { idField: "id" }
  );
  const [dataUserVoucher, loadDataUserVoucher] = useDocumentData(
    firestore.doc(`users/${profil?.id}/vouchers/${subcart?.promo_voucher}`),
    { idField: "id" }
  );

  const refTotal = useRef({});
  const totalHarga = useMemo(() => {
    const prices = Object.values(refTotal.current);
    if (prices.length >= products.length) {
      return prices?.reduce((prev, curr) => prev + Math.round(curr), 0);
    }

    return 0;
  }, [refTotal.current]);

  const setProducts = useCallback(async (id, jumlah, harga) => {
    refTotal.current = { ...refTotal.current, [id]: jumlah * harga };
  }, []);

  const refLevel = useRef({});
  const totalHargaLevel = useMemo(() => {
    const prices = Object.values(refLevel.current);
    if (prices.length >= products.length) {
      return prices?.reduce((prev, curr) => prev + Math.round(curr), 0);
    }

    return 0;
  }, [refLevel.current]);

  const setProductsLevel = useCallback(async (id, jumlah, harga) => {
    refLevel.current = { ...refLevel.current, [id]: jumlah * harga };
  }, []);

  const productValue =
    products?.product_value !== undefined &&
    products?.product_value !== "" &&
    !Number.isNaN(products?.product_value) &&
    products?.product_value >= 0
      ? products?.product_value
      : 1;

  const komisi = Math.round(global_komisi?.[level?.level] * productValue * 100);

  const [cekAuto, setCekAuto] = useState(false);

  useEffect(() => {
    if (global_settings?.aktivasi_auto_voucher) {
      autoVoucher();
    } else {
      setCekAuto(true);
    }
  }, []);

  useEffect(() => {
    if (totalHarga > 0 && cekAuto) {
      calculateAll();
    }
  }, [
    subcart?.inpoin,
    subcart?.promo_voucher,
    totalHarga,
    dataUserVoucher?.status,
    dataVoucher?.status,
  ]);

  const autoVoucher = async () => {
    // console.log("voc");
    setCekAuto(true);
    setLoadDebounce(true);
    const voucher = voucherData.filter(
      (item) =>
        item?.auto &&
        checkProductSyarat(
          item?.syarat?.tipe,
          item?.syarat?.min_transaksi,
          subcart?.total_tagihan_harga_normal,
          item?.syarat?.min_produk,
          item?.syarat?.products,
          subcart?.products
        )
    )?.[0];
    if (voucher) {
      let isHarganormal = voucher?.harga_normal
        ? {
            nilai_voucher_before: voucher?.voucher,
          }
        : "";
      await cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              promo_voucher: voucher?.nama?.toUpperCase(),
              ...isHarganormal,
              kategori_voucher: voucher?.kategori
                ? voucher?.kategori
                : "produk",
            },
          },
          updated_at: FieldValue.serverTimestamp(),
        },
        { merge: true }
      );
    }
    // setLoadDebounce(false);
  };

  const calculateAll = async () => {
    // console.log("itung");
    setLoadDebounce(true);
    if (subcart?.promo_voucher) {
      const findVoucher = await findOneVoucher(
        subcart?.promo_voucher,
        subcart?.total_tagihan,
        subcart?.pengiriman?.finalRate,
        subcart?.nilai_promo_ongkir
      );
      // console.log("lol",findVoucher);
      await cartRef
        .set(
          {
            subcarts: {
              [alamatId]: {
                nilai_voucher: subcart?.promo_voucher
                  ? findVoucher ?? 0
                  : FieldValue.delete(),
                total_tagihan:
                  findVoucher && subcart?.kategori_voucher === "produk"
                    ? totalHarga - findVoucher
                    : totalHarga,
                total_tagihan_before_vouher:
                  findVoucher && subcart?.kategori_voucher === "produk"
                    ? totalHarga
                    : FieldValue.delete(),
                nilai_promo_produk: totalHargaLevel - totalHarga ?? 0,
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        )
        .catch((err) => console.log("error effect total_tagihan", err));
    } else if (subcart?.inpoin) {
      if (subcart?.inpoin?.category === "produk") {
        await cartRef
          .set(
            {
              subcarts: {
                [alamatId]: {
                  nilai_voucher: Math.round(subcart?.inpoin?.coin),
                  total_tagihan: totalHarga - Math.round(subcart?.inpoin?.coin),
                  nilai_promo_produk: totalHargaLevel - totalHarga ?? 0,
                },
              },

              updated_at: FieldValue.serverTimestamp(),
            },
            { merge: true }
          )
          .catch((err) => console.log("error effect total_tagihan", err));
      }
    } else {
      await cartRef
        .set(
          {
            subcarts: {
              [alamatId]: {
                total_tagihan: totalHarga,
                nilai_promo_produk: totalHargaLevel - totalHarga ?? 0,
              },
            },

            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        )
        .catch((err) => console.log("error effect total_tagihan", err));
    }
    setLoadDebounce(false);
  };

  const findOneVoucher = async (
    promo_voucher,
    totalTagihan,
    finalRate,
    nilai_promo_ongkir
  ) => {
    if (promo_voucher) {
      const datas = await getDataVoucher(promo_voucher, profil?.id);
      const check_quota =
        datas?.quota - (datas?.quota_used ? datas?.quota_used : 0);
      let nilai = 0;
      let nilaiOngkir = finalRate - nilai_promo_ongkir ?? 0;
      console.log(
        Number(datas?.min_transaksi) > (totalHarga ? totalHarga : totalTagihan),
        datas?.status === "inactive",
        check_quota < 1,
        !checkProductSyarat(
          datas?.syarat?.tipe,
          datas?.syarat?.min_transaksi,
          subcart?.total_tagihan_harga_normal,
          datas?.syarat?.min_produk,
          datas?.syarat?.products,
          subcart?.products
        )
      );
      if (
        Number(datas?.min_transaksi) >
          (totalHarga ? totalHarga : totalTagihan) ||
        datas?.status === "inactive" ||
        check_quota < 1 ||
        !checkProductSyarat(
          datas?.syarat?.tipe,
          datas?.syarat?.min_transaksi,
          subcart?.total_tagihan_harga_normal,
          datas?.syarat?.min_produk,
          datas?.syarat?.products,
          subcart?.products
        )
      ) {
        try {
          cartRef.set(
            {
              subcarts: {
                [alamatId]: {
                  nilai_voucher: FieldValue.delete(),
                  promo_voucher: FieldValue.delete(),
                  kategori_voucher: FieldValue.delete(),
                },
              },
              updated_at: FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
        } catch (error) {
          console.log(error.message);
        }
        enqueueSnackbar("Voucher tidak  bisa di gunakan", { variant: "error" });
        return nilai;
      }
      if (datas?.kategori === "ongkir") {
        if (datas?.tipe === "%") {
          nilai = (finalRate * datas?.voucher) / 100;
          nilai = datas?.max_voucher < nilai ? datas?.max_voucher : nilai;
        } else {
          nilai = datas?.voucher;
        }
        nilai = nilai > nilaiOngkir ? nilaiOngkir : nilai;
        return nilai;
      } else {
        if (datas?.tipe === "%") {
          nilai = (totalTagihan * datas?.voucher) / 100;
          nilai = datas?.max_voucher < nilai ? datas?.max_voucher : nilai;
        } else {
          if (datas?.harga_normal) {
            let nilai_potongan = (datas?.voucher * komisi) / 100;
            nilai = datas?.voucher - nilai_potongan;
          } else {
            nilai = datas?.voucher;
          }
        }
        nilai = nilai > totalHarga ? totalHarga : nilai;
        return nilai;
      }
    } else {
      return 0;
    }
  };

  const checkProductSyarat = (
    type,
    min_transaksi,
    tagihan,
    min_produk,
    arr1,
    obj2
  ) => {
    if (type) {
      const values = Object.values(obj2);
      const arr = [
        ...values
          ?.filter((val) => arr1?.includes(val?.product))
          ?.map((item) => item?.product),
      ];
      // console.log(arr, arr1, values, arr.length, min_transaksi, tagihan);
      if (type == "includes") {
        for (let i = 0; i < values.length; i++) {
          if (arr1.includes(values[i].product)) {
            return true;
          }
        }
        return false;
      } else if (type == "only") {
        for (let i = 0; i < values.length; i++) {
          if (!arr1.includes(values[i].product)) {
            return false;
          }
        }
        if (min_transaksi > tagihan) {
          return false;
        }
        if (arr.length > 0 && arr.length < min_produk) {
          return false;
        }
        return true;
      } else if (type == "all") {
        const isAllProductsInArray2 =
          values.reduce((set, { product }) => set.add(product), new Set())
            .size >= arr1.length;
        return isAllProductsInArray2;
      }
    } else {
      return true;
    }
  };

  return (
    <>
      <Alamat id={alamatId} subcart={subcart} />
      {/* <Divider /> */}
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          style={{ minHeight: "0px" }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "-20px",
              marginBottom: "-20px",
            }}
          >
            <LocalMallOutlinedIcon />
            <Gap width={16} />
            <Typography className={classes.liquidPrimary}>
              Jumlah Produk: {products.length}
            </Typography>
          </div>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <div style={{ width: "100%" }}>
            {products
              .sort((a, b) => {
                return (
                  a[1].created_at?.toMillis?.() - b[1].created_at?.toMillis?.()
                );
              })
              .map(([variantId, variant], index) => {
                return (
                  <Item
                    alamatId={alamatId}
                    variantId={variantId}
                    variant={variant}
                    callSetInvalidJumlah={callSetInvalidJumlah}
                    index={index}
                    setProducts={setProducts}
                    setProductsLevel={setProductsLevel}
                  />
                );
              })}
          </div>
        </AccordionDetails>
      </Accordion>
      {/* <Divider /> */}
      <Pengiriman
        loadDebounce={loadDebounce}
        alamatId={alamatId}
        subcart={subcart}
        setLoadDebounce={setLoadDebounce}
        loadDelivery={loadDelivery}
        setLoadDelivery={setLoadDelivery}
        findOneVoucher={findOneVoucher}
        tipe_order={tipe_order}
      />
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{ marginRight: "25px" }}
          className={classes.liquidSmall}
        >
          Pesan
        </Typography>
        <Typography className={classes.liquidSmall}>
          {subcart?.note ? subcart?.note : "-"}
        </Typography>
      </div>
      <Divider />
      <div className={classes.totalHarga}>
        <Typography className={classes.liquidPrimary}>
          Total Harga{" "}
          <span style={{ color: "gray" }}>{products?.length} produk</span>
        </Typography>
        <Typography color="primary" className={classes.liquidPrimary}>
          {currency(subcart?.total_tagihan)}
        </Typography>
      </div>
      <Divider style={{ height: "5px" }} />
      <Voucher
        alamatId={alamatId}
        subcart={subcart}
        cartRef={cartRef}
        getDataVoucher={getDataVoucher}
        checkProductSyarat={checkProductSyarat}
        loadDebounce={loadDebounce}
        loadDelivery={loadDelivery}
      />
      {campaignsInfaq.length > 0 && subcart?.type !== "preorder" && (
        <>
          <Divider style={{ height: "5px" }} />
          <Infaq
            loadDebounce={loadDebounce}
            loadDelivery={loadDelivery}
            setLoadDebounce={setLoadDebounce}
            alamatId={alamatId}
            subcart={subcart}
          />
        </>
      )}
      <Divider style={{ height: "5px" }} />
      <div
        style={{
          margin: "10px",
        }}
      >
        <Typography className={classes.liquidSmallBold}>
          Ringkasan belanja
        </Typography>
        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
        {(subcart?.nilai_voucher && subcart?.promo_voucher) ||
        subcart?.inpoin?.category ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Subtotal harga normal ({products.length} Produk)
              </Typography>
              <Typography className={classes.liquidPrimary}>
                {currency(subcart?.total_tagihan_harga_normal)}
              </Typography>
            </div>
            {subcart?.nilai_voucher_before ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography className={classes.liquidPrimary}>
                  Nominal voucher
                </Typography>
                <Typography className={classes.liquidPrimary}>
                  - {currency(subcart?.nilai_voucher_before)}
                </Typography>
              </div>
            ) : null}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Subtotal harga level ({products.length} Produk)
              </Typography>
              <Typography className={classes.liquidPrimary}>
                {currency(subcart?.total_tagihan + subcart?.nilai_voucher)}
              </Typography>
            </div>
            {!subcart?.nilai_voucher_before ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography className={classes.liquidPrimary}>
                  Diskon Voucher{" "}
                  {subcart?.kategori_voucher || subcart?.inpoin?.category}
                </Typography>
                <Typography className={classes.liquidPrimary}>
                  - {currency(subcart?.nilai_voucher)}
                </Typography>
              </div>
            ) : null}
          </>
        ) : null}{" "}
        {subcart?.nilai_promo_ongkir ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Diskon Ongkir
              </Typography>
              <Typography className={classes.liquidPrimary}>
                - {currency(subcart?.nilai_promo_ongkir)}
              </Typography>
            </div>
          </>
        ) : null}{" "}
        {subcart?.nilai_promo_produk ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Diskon Produk
              </Typography>
              <Typography className={classes.liquidPrimary}>
                - {currency(subcart?.nilai_promo_produk)}
              </Typography>
            </div>
          </>
        ) : null}
        {subcart?.nilai_infaq > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.liquidPrimary}>
              {campaignsInfaq?.[0]?.tipe}
            </Typography>
            <Typography className={classes.liquidPrimary}>
              {currency(subcart?.nilai_infaq)}
            </Typography>
          </div>
        ) : null}{" "}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography className={classes.liquidPrimary}>
            Total Harga ({products?.length} Produk)
          </Typography>
          <Typography className={classes.liquidPrimary}>
            {currency(subcart?.total_tagihan)}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography className={classes.liquidPrimary}>
            Total Ongkos Kirim
          </Typography>
          <Typography className={classes.liquidPrimary}>
            {currency(subcart?.biaya_pengiriman)}
          </Typography>
        </div>
        {preorderUtils?.down_payment_option && subcart?.nilai_dp > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.liquidPrimary}>
              Total Down Payment
            </Typography>
            <Typography className={classes.liquidPrimary}>
              {currency(Math.round(subcart?.nilai_dp))}
            </Typography>
          </div>
        )}
        {subcart?.resi_otomatis_mp ? null : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.liquidPrimary}>Asuransi</Typography>
            <Typography className={classes.liquidPrimary}>
              {currency(
                subcart?.pakai_asuransi ? subcart?.asuransi_pengiriman : 0
              )}
            </Typography>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography className={classes.liquidPrimary}>Berat Total</Typography>
          <Typography className={classes.liquidPrimary}>
            {subcart?.berat_total} gr
          </Typography>
        </div>
      </div>
      <Divider style={{ height: "5px" }} />
    </>
  );
};

export default Checkout;
